module.exports = __webpack_public_path__ + "static/img/samrani-jordan.c46af03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/samrani-jordan.jpg
// module id = JgHI
// module chunks = 0